import React,{useEffect} from 'react'
import Header from '../../components/Header'
import AddUsers from '../../components/AddUsers'

const OrgProfile =()=>{
  useEffect(()=>{
    document.title = 'Add Users - Nclude Portal';
  },[])
  return (
    <div className=''>
        <Header />
        <AddUsers/>
    </div>
  )
}

export default OrgProfile